import { API_URL, itemPerPage } from '../constants/index.js';

import {
    DEVICE,
    DEVICE_SUCCESS,
    DEVICE_ERROR,
    DEVICE_ID,
    DEVICE_ID_SUCCESS,
    DEVICE_ID_ERROR,
    ADD_DEVICE,
    ADD_DEVICE_SUCCESS,
    ADD_DEVICE_ERROR,
    UPDATE_DEVICE,
    UPDATE_DEVICE_SUCCESS,
    UPDATE_DEVICE_ERROR,
    ADD_MESSAGE,
    ADD_MESSAGE_SUCCESS,
    ADD_MESSAGE_ERROR,
    UNREGISTER_RESIDENTS,
    UNREGISTER_RESIDENTS_SUCCESS,
    UNREGISTER_RESIDENTS_ERROR,
    UNREGISTER_RESIDENTS_FILTERS,
    UNREGISTER_RESIDENTS_FILTERS_SUCCESS,
    UNREGISTER_RESIDENTS_FILTERS_ERROR,
    CLEAR_DEVICES,
    DEVICE_SORT,
    DEVICE_SORT_SUCCESS,
    DEVICE_SORT_ERROR,
    DEVICE_RESIDENTS,
    DEVICE_RESIDENTS_SUCCESS,
    DEVICE_RESIDENTS_ERROR,
    DEVICE_LOCATIONS,
    DEVICE_LOCATIONS_SUCCESS,
    DEVICE_LOCATIONS_ERROR,
    DEVICE_SERIALS,
    DEVICE_SERIALS_SUCCESS,
    DEVICE_SERIALS_ERROR,
    ADD_MESSAGE_FILTERS,
    ADD_MESSAGE_FILTERS_SUCCESS,
    ADD_MESSAGE_FILTERS_ERROR,
    DEVICE_ALL_SUCCESS,
    EXPORT_DEVICE,
    EXPORT_DEVICE_SUCCESS,
    EXPORT_DEVICE_ERROR,
    DEVICE_DOCSIS,
    DEVICE_DOCSIS_SUCCESS,
    DEVICE_DOCSIS_ERROR
} from '../constants/devicesConstants';
import { sweetAlert } from '../components/Alert/sweetAlert';

import * as XLSX from 'xlsx';

//#region GET DEVICE
export function getDevices(data) {
    return {
        type: DEVICE,
        data
    }
};

export function getDevicesSuccess(data) {
    return {
        type: DEVICE_SUCCESS,
        data
    }
};

export function getDevicesError(data) {
    return {
        type: DEVICE_ERROR,
        data
    }
};

export function GetAllDevices(idCommunity, currentPage) {
    return dispatch => {


        dispatch(getDevices());

        fetch(`${API_URL}cms/devices/devices/${idCommunity}?limit=${itemPerPage}&page=${currentPage}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(res => {

                dispatch(getDevicesSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesError(error));

            })


    }
};


export function getAllDevicesSuccess(data) {
    return {
        type: DEVICE_ALL_SUCCESS,
        data
    }
};

export function GetAllDevicesNoPagination(idCommunity) {
    return dispatch => {


        dispatch(getDevices());

        fetch(`${API_URL}/devices/devicesByCommunity/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getAllDevicesSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesError(error));

            })


    }
};

//#endregion

//#region GET DEVICE SORT
export function getDevicesSort(data) {
    return {
        type: DEVICE_SORT,
        data
    }
};

export function getDevicesSortSuccess(data, page) {
    return {
        type: DEVICE_SORT_SUCCESS,
        data,
        page
    }
};

export function getDevicesSortError(data) {
    return {
        type: DEVICE_SORT_ERROR,
        data
    }
};

const getHeaders = (sort, direction, filters, idCommunity) => {

    const headers = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Authorization': 'Bearer ' + localStorage.getItem('token'),
        'CommunityId': idCommunity,
        'custom_sort': sort,
        'sort_dir': direction === true ? 1 : -1
    }

    if (filters?.ResidentFilter) {
        headers.resident = filters.ResidentFilter
    }

    if (filters?.zoneNameFilter) {
        headers.location = filters.zoneNameFilter
    }

    if (filters?.SerialNumberFilter) {
        headers.serial = filters.SerialNumberFilter
    }

    if(filters?.docsisFilter){
        headers.docsis = filters.docsisFilter
    }

    return headers;
}

export function GetDevicesSorted(idCommunity, currentPage, sort, direction, filters) {
    return async (dispatch) => {
        dispatch(getDevicesSort());

        try {
            const response = await fetch(`${API_URL}/devices/sort/${idCommunity}?limit=${itemPerPage}&page=${currentPage}`,
                {
                    method: 'GET',
                    headers: getHeaders(sort, direction, filters, idCommunity)
                });

            if (response.status === 200) {
                const data = await response.json();
                dispatch(getDevicesSortSuccess(data, currentPage));

                return data.data;
            }


        } catch (error) {
            dispatch(getDevicesSortError(error));
        }


    }

};

//#endregion GET DEVICE SORT

export function getDevicesResidents(data) {
    return {
        type: DEVICE_RESIDENTS,
        data
    }
};

export function getDevicesResidentsSuccess(data, page) {
    return {
        type: DEVICE_RESIDENTS_SUCCESS,
        data
    }
};

export function getDevicesResidentsError(data) {
    return {
        type: DEVICE_RESIDENTS_ERROR,
        data
    }
};

export function GetDevicesResidents(idCommunity) {
    return dispatch => {
        dispatch(getDevicesResidents());

        fetch(`${API_URL}/devices/residents/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDevicesResidentsSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesResidentsError(error));

            })


    }
};

export function getDevicesLocations(data) {
    return {
        type: DEVICE_LOCATIONS,
        data
    }
};

export function getDevicesLocationsSuccess(data, page) {
    return {
        type: DEVICE_LOCATIONS_SUCCESS,
        data
    }
};

export function getDevicesLocationsError(data) {
    return {
        type: DEVICE_LOCATIONS_ERROR,
        data
    }
};

export function GetDevicesLocations(idCommunity) {
    return dispatch => {
        dispatch(getDevicesLocations());

        fetch(`${API_URL}/devices/locations/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDevicesLocationsSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesLocationsError(error));

            })


    }
};

export function getDevicesSerials(data) {
    return {
        type: DEVICE_SERIALS,
        data
    }
};

export function getDevicesSerialsSuccess(data, page) {
    return {
        type: DEVICE_SERIALS_SUCCESS,
        data
    }
};

export function getDevicesSerialsError(data) {
    return {
        type: DEVICE_SERIALS_ERROR,
        data
    }
};

export function GetDevicesSerials(idCommunity) {
    return dispatch => {
        dispatch(getDevicesSerials());

        fetch(`${API_URL}/devices/serial/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDevicesSerialsSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesSerialsError(error));

            })


    }
};

export function getDevicesDocsis(data) {
    return {
        type: DEVICE_DOCSIS,
        data
    }
};

export function getDevicesDocsisSuccess(data, page) {
    return {
        type: DEVICE_DOCSIS_SUCCESS,
        data
    }
};

export function getDevicesDocsisError(data) {
    return {
        type: DEVICE_DOCSIS_ERROR,
        data
    }
};

export function GetDevicesDocsis(idCommunity) {
    return dispatch => {
        dispatch(getDevicesDocsis());

        fetch(`${API_URL}/devices/docsis/${idCommunity}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDevicesDocsisSuccess(res));

                return res;
            })
            .catch(error => {
                dispatch(getDevicesDocsisError(error));

            })


    }
};

//#region Get Device

export function getDevice(data) {
    return {
        type: DEVICE_ID,
        data
    }
};

export function getDeviceSuccess(data) {
    return {
        type: DEVICE_ID_SUCCESS,
        data
    }
};

export function getDeviceError(data) {
    return {
        type: DEVICE_ID_ERROR,
        data
    }
};

export function GetDevice(idDevice, idCommunity) {
    return dispatch => {
        dispatch(getDevice());

        return fetch(API_URL + 'devices/device/' + idDevice,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(res => res.json())
            .then(res => {
                dispatch(getDeviceSuccess(res));
                return res;
            })
            .catch(error => {
                dispatch(getDeviceError(error));

            })
    }
}

//#endregion

//#region  Add Device
export function addDevice(data) {
    return {
        type: ADD_DEVICE,
        data
    }
};

export function addDeviceSuccess(data) {
    return {
        type: ADD_DEVICE_SUCCESS,
        data
    }
};

export function addDeviceError(data) {
    return {
        type: ADD_DEVICE_ERROR,
        data
    }
};

export function AddDevice(data, idCommunity, styles = '') {
    return dispatch => {
        dispatch(addDevice());

        fetch(API_URL + 'devices/device',
            {
                body: JSON.stringify(data),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity
                }
            })
            .then(r => r.json().then(data => ({ status: r.status, body: data })))
            .then(res => {

                let message;
                if (res.status === 201) {
                    dispatch(addDeviceSuccess(res.body));
                    message = `The device has been added successfully`
                    sweetAlert('success', message, 'alert_AddDevice_Success', styles);
                    return res.body;
                }

                message = res.body.message;
                sweetAlert('warning', message, 'alert_AddDevice_Warning', styles);
                dispatch(addDeviceError(res.body));

            })
            .catch(error => {
                const message = `An error occurred when adding the device`
                dispatch(addDeviceError(error));

                sweetAlert('error', message, 'alert_AddDevice_Error', styles);
            })
    }
};
//#endregion

//#region  Update Device
export function updDevice(data) {
    return {
        type: UPDATE_DEVICE,
        data
    }
};

export function updDeviceSuccess(data) {
    return {
        type: UPDATE_DEVICE_SUCCESS,
        data
    }
};

export function updDeviceError(data) {
    return {
        type: UPDATE_DEVICE_ERROR,
        data
    }
};

export function UpdDevice(idDevice, data, idCommunity, styles = '') {
    return dispatch => {
        dispatch(updDevice());

        fetch(API_URL + 'devices/device/' + idDevice,
            {
                body: JSON.stringify(data),
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(res => {
                const message = `The device has been updated successfully`

                dispatch(updDeviceSuccess(data));

                sweetAlert('success', message, 'alert_DeviceUpdate_Success', styles);
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while Updating the device`

                dispatch(updDeviceError(error));

                sweetAlert('error', message, 'alert_DeviceUpdate_Error', styles);

            })
    }
};
//#endregion

//#region  Add Message
export function addMessage(data) {
    return {
        type: ADD_MESSAGE,
        data
    }
};

export function addMessageSuccess(data) {
    return {
        type: ADD_MESSAGE_SUCCESS,
        data
    }
};

export function addMessageError(data) {
    return {
        type: ADD_MESSAGE_ERROR,
        data
    }
};

export function AddMessage(data, idCommunity, styles = '') {
    return dispatch => {
        dispatch(addMessage());

        fetch(API_URL + 'devices/message',
            {
                body: JSON.stringify(data),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'CommunityId': idCommunity,
                }
            })
            .then(r => r.json().then(data => ({ status: r.status, body: data })))
            .then(res => {
                let message = '';
                if (res.status === 201 || res.status === 200) {
                    dispatch(addMessageSuccess(res.body));
                    message = `The message has been sent successfully`
                    sweetAlert('success', message, 'alert_DeviceMessage_Success', styles);
                    return res.body;
                } else if (res.status === 401) {
                    message = `An error occurred trying to sent the message: ${res.body.message} `;
                    sweetAlert('warning', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(addMessageError(message));
                    return res.body;
                } else if (res.status === 400) {
                    message = `An error occurred trying to sent the message: ${res.body.message} `;
                    sweetAlert('error', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(addMessageError(message));
                    return res.body;
                }
            })
            .catch(error => {

                const message = `An error has occurred while sending the message`;


                dispatch(addMessageError(error));

                sweetAlert('error', message, 'alert_DeviceUpdate_Error', styles);
            })
    }
};


//#endregion

export function addMessageFilters(data) {
    return {
        type: ADD_MESSAGE_FILTERS,
        data
    }
};

export function addMessageFiltersSuccess(data) {
    return {
        type: ADD_MESSAGE_FILTERS_SUCCESS,
        data
    }
};

export function addMessageFiltersError(data) {
    return {
        type: ADD_MESSAGE_FILTERS_ERROR,
        data
    }
};

export function AddMessageFilter(communityId, filters, data, sort, direction, styles = '') {
    return dispatch => {
        dispatch(addMessageFilters());

        const headers = getHeaders(sort, direction, filters, communityId);

        fetch(API_URL + 'devices/messageAll',
            {
                body: JSON.stringify(data),
                method: 'POST',
                headers: headers
            })
            .then(r => r.json().then(data => ({ status: r.status, body: data })))
            .then(res => {
                let message = '';
                if (res.status === 201 || res.status === 200) {
                    dispatch(addMessageFiltersSuccess(res.body));
                    message = `The message has been sent successfully`
                    sweetAlert('success', message, 'alert_DeviceMessage_Success', styles);
                    return res.body;
                } else if (res.status === 401) {
                    message = `An error occurred trying to sent the message: ${res.body.message} `;
                    sweetAlert('warning', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(addMessageFiltersError(message));
                    return res.body;
                } else if (res.status === 400) {
                    message = `An error occurred trying to sent the message: ${res.body.message} `;
                    sweetAlert('error', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(addMessageFiltersError(message));
                    return res.body;
                }
            })
            .catch(error => {

                const message = `An error has occurred while sending the message`

                dispatch(addMessageError(error));

                sweetAlert('error', message, 'alert_DeviceUpdate_Error');
            })
    }
};

export function AddMessageChangeStatus() {
    return dispatch => {
        dispatch(getDeviceSuccess());
    }
};




//#region Unregister
export function unregisterResidents(data) {
    return {
        type: UNREGISTER_RESIDENTS,
        data
    }
};

export function unregisterResidentsSuccess(data) {
    return {
        type: UNREGISTER_RESIDENTS_SUCCESS,
        data
    }
};

export function unregisterResidentsError(data) {
    return {
        type: UNREGISTER_RESIDENTS_ERROR,
        data
    }
};

export function UnregisterResidents(devices, communityId, data, styles = '') {
    return dispatch => {
        dispatch(unregisterResidents());

        fetch(API_URL + 'devices/unregister',
            {
                body: JSON.stringify(data),
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache, no-store, must-revalidate',
                    'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    'devices': devices,
                    'communityId': communityId
                }
            })
            .then(res => {
                const message = `The unregistration has been sent successfully`

                dispatch(updDeviceSuccess(data));

                sweetAlert('success', message, 'alert_UnregistrationDevice_Success', styles);
                return res;
            })
            .catch(error => {
                const message = `An error has occurred while sending the message`

                dispatch(addMessageError(error));

                sweetAlert('error', message, 'alert_UnregistrationDevice_Error');
            })
    }
};


export function unregisterResidentsFilters(data) {
    return {
        type: UNREGISTER_RESIDENTS_FILTERS,
        data
    }
};

export function unregisterResidentsFiltersSuccess(data) {
    return {
        type: UNREGISTER_RESIDENTS_FILTERS_SUCCESS,
        data
    }
};

export function unregisterResidentsFiltersError(data) {
    return {
        type: UNREGISTER_RESIDENTS_FILTERS_ERROR,
        data
    }
};

export function UnregisterResidentsFilter(communityId, filters, data, sort, direction, styles = '') {
    return dispatch => {
        dispatch(unregisterResidentsFilters());

        const headers = getHeaders(sort, direction, filters, communityId);

        fetch(API_URL + 'devices/unregisterAll',
            {
                body: JSON.stringify(data),
                method: 'DELETE',
                headers: headers
            })
            .then(res => {
                const message = `The unregistration has been sent successfully`

                dispatch(updDeviceSuccess(data));

                sweetAlert('success', message, 'alert_UnregistrationDevice_Success', styles);
                return res;
            })
            .catch(error => {
                dispatch(unregisterResidentsFiltersError(error));

            })
    }
};


export const ClearDevices = () => ({ type: CLEAR_DEVICES })
//#endregion

//#region GET EXPORT DEVICES

export function exportDevices(data) {
    return {
        type: EXPORT_DEVICE,
        data
    }
};

export function exportDevicesSuccess(data) {
    return {
        type: EXPORT_DEVICE_SUCCESS,
        data
    }
};

export function exportDevicesError(data) {
    return {
        type: EXPORT_DEVICE_ERROR,
        data
    }
};

export function ExportDevices(idCommunity, communityName, styles = '') {
    return async dispatch => {

        dispatch(exportDevices());
        const newCommunityName = communityName ? communityName.split(' ').filter(a => a.length > 0).map(a => a.trim()).join('_') : '';

        const headers = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache, no-store, must-revalidate',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
        }

        fetch(API_URL + `devices/export/${idCommunity}`,
            {
                method: 'GET',
                headers: headers
            })
            .then(r => r.json().then(data => ({ status: r.status, body: data })))
            .then(res => {
                let message = '';
                if (res.status === 201 || res.status === 200) {
                    dispatch(exportDevicesSuccess(res.body));
                    let dataObj = res.body;
                    let data = dataObj.data;

                    if (data && data.length > 0) {
                        const workSheet = XLSX.utils.json_to_sheet(data);
                        const workBook = XLSX.utils.book_new();

                        XLSX.utils.book_append_sheet(workBook, workSheet, "devices");

                        const fileName = `Devices_${newCommunityName}.csv`

                        XLSX.writeFile(workBook, fileName);
                    }

                    message = `The message has been sent successfully`
                    sweetAlert('success', message, 'alert_DeviceMessage_Success', styles);
                    return res.body;
                } else if (res.status === 401) {
                    message = `An error occurred trying to sent the message `;
                    sweetAlert('warning', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(exportDevicesError(message));
                    return res.body;
                } else if (res.status === 400) {
                    message = `An error occurred trying to sent the message `;
                    sweetAlert('error', message, 'alert_DeviceUpdate_Error', styles);
                    dispatch(exportDevicesError(message));
                    return res.body;
                }

            })
            .catch(error => {
                dispatch(unregisterResidentsFiltersError(error));
            })

        dispatch(exportDevicesSuccess)
    }
}


//#endregion